import React, { Component } from 'react'
import { Box } from '@mui/material'
import { IHocLazyOptions } from '@lib/ReduxBase'
import { ApiAlertContext } from '@lib/ApiContext'
import { ICategoryDetailReduxProps } from '../redux.types'
import { CreateAutoCompleteMultipleControl } from './SelectMultipleControl'
import { ICategoryDetailOtherProps, ISelectCategoryChange, TCategoryDetailDTO } from '../types'
import { compareArrays, getCategoriesByListName, mapCategoriesToCategoryDetailDTOs, mapCategoryDetailDTOs, parseValue } from './helper'
import OverlayLazy from './OverlayLazy'

const SelectInput = CreateAutoCompleteMultipleControl()

interface IProps extends ICategoryDetailReduxProps, IHocLazyOptions<ICategoryDetailOtherProps> {}
export default class CategorySelectMultiple extends Component<IProps> {
  listOld: TCategoryDetailDTO[] = []
  constructor(props: IProps) {
    super(props)
    this.intitialData()
  }

  intitialData = () => {
    this.listOld = mapCategoryDetailDTOs(this.props.slice.categoryDetails)
  }

  render() {
    const options = this.getOptions()
    const defaultValue = this.getDefaultValue()
    return (
      <Box sx={{ position: 'relative' }}>
        <SelectInput
          disabled
          key={JSON.stringify(defaultValue)}
          fullWidth
          freeSolo
          // onBlur={() => this.props.onBlur && this.props.onBlur('CategoryNames')}
          // {...getErrorMessage(this.props.messageErrors, 'CategoryNames')}
          options={options}
          defaultValue={defaultValue}
          name='CategoryNames'
          title='CategoryNames'
          onChange={this.handleOnChange}
        />
        <OverlayLazy in={this.props.slice.loading} />
      </Box>
    )
  }

  componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<{}>, snapshot?: any): void {
    if (this.props.slice.categoryDetails.length !== prevProps.slice.categoryDetails.length) {
      this.intitialData()
    }
  }

  getOptions = (): string[] => {
    const categories = this.props.slice.categories
    return Array.from(new Set<string>(categories.map((e) => e?.Name).filter((x) => !!x)))
  }

  getDefaultValue = (): string[] => {
    const list = this.props.slice.categoryDetails.map((e) => e?.Category?.Name)
    return list.filter((x) => !!x) as string[]
  }

  handleOnChange = async (value: any[]) => {
    const pValue = parseValue(value)
    const categories = this.props.slice.categories
    const newValue = getCategoriesByListName(categories, pValue)
    const mediaId = this.props.param?.mediaId ?? ''
    const list = mapCategoriesToCategoryDetailDTOs(mediaId, newValue)
    const changes = compareArrays({ mediaId, categories, listOld: this.listOld, list: list })
    this.listOld = list
    if (!changes.length) return
    await Promise.all(changes.map((x) => this.callAPI(x)))
  }

  callAPI = async (item: ISelectCategoryChange) => {
    if (!this.props.slice.mediaId) {
      ApiAlertContext.ApiAlert?.PushWarning(`MediaId not found!`)
      return
    }
    try {
      await this.props.onUpdateCategory(item)
    } catch (error) {
      // throw error
    } finally {
    }
  }
}
